<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
        <header-component :headerTitle="headerText" />
        <v-snackbar
            v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
            <v-layout align-center pr-4>
                <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
                <v-layout column>
                <div>{{ snackbar.text }}</div>
                </v-layout>
            </v-layout>
            <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
                <v-icon>clear</v-icon>
            </v-btn>
        </v-snackbar>
        <v-row justify="center">
        <v-dialog v-model="downloadDialog" persistent max-width="364px">
          <v-card class="v-card-100">
            <v-card-title class="d-flex">
              <span>Download</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="downloadDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="2" class="border-opacity-50 m-0"/>
              <v-card-text class="download-email">
                <v-row>
                  <v-col cols="12" sm="4" md="12">
                    <v-text-field label="Email Id" :rules="emailRules" @input="validateEmail" variant="outlined"  v-model="email_id" type="text"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions center>
              <v-spacer></v-spacer>
              <v-btn variant="outlined" class="text-none" size="large" color="primary" @click="downloadDialog = false">Cancel</v-btn>
              <v-btn variant="flat" class="text-none" size="large" color="primary" @click="downloadFile('submit')" :disabled="!isEmailValid || number > 0">Submit</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
       </v-row>
        <CommonDialog
          v-model="openDialog"
           :title="titleText"
           max-width="500px"
           cancelText="Cancel"
           submitText="Add"
           :submitDisabled="!checkFormData"
           @submit="submitForm"
        >
          <template #body>
            <v-row v-if="active_tab === 'Return Types Master'">
              <v-col cols="12" sm="6" md="6">
              <v-text-field class="text-left" v-model="return_type" label="Return Type" variant="outlined" :disabled="titleText === 'Update'"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field class="text-left" v-model="description" label="Description" variant="outlined"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" sm="6" md="6">
              <v-text-field class="text-left" v-model="product" label="Product Name" variant="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
              <v-text-field class="text-left" v-model="description_product" label="description" variant="outlined"></v-text-field>
              </v-col>
            </v-row>
          </template>
        </CommonDialog>
        <v-row justify="center">
        <v-dialog content-class="filter-dispatch" v-model="filteWithSubPopup" persistent :max-width="organization_name === 'Voltas' ? '1224px' : '600px'">
            <v-card class="filter_ui">
            <v-card-actions>
                <v-row class="mt-2">
                <v-col cols="12" sm="12" md="12">
                  <v-combobox prepend-inner-icon="mdi-magnify" clearable v-model="data_entry" :items="data_entry_items" :label="active_tab === 'Front End Title Master' ? 'Screen Name' : 'Data Entity'" variant="outlined"> </v-combobox>
                </v-col>
                </v-row>
            </v-card-actions>
            <v-card-actions class="margin-10">
                <v-spacer></v-spacer>
                <v-btn class="text-none" size="small" variant="outlined" color="primary" @click="filteWithSubPopup = false">Cancel</v-btn>
                <v-btn class="text-none" size="small" variant="flat" color="primary" @click="loadData(active_tab, 'filter')">Apply Filter(S)</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        </v-row>
        <v-card class="v-card-100">
            <v-tabs v-model="tab_index" class="custom-tabs">
                <v-tab class="component-tab-heading" ripple :href="'#'" @click="loadData(tab, 'tab_clicked')"
                style="text-transform:none!important;text-decoration: none;" v-for="(tab, index) in tabs"
                :key="index">{{ tab }}</v-tab>
            </v-tabs>
        </v-card>
      <div v-if="active_tab !== 'General Setting'">
        <v-card-title class="action-style pt-4 pb-6">
            <!-- Search fields -->
            <v-row class="ma-1">
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" class="mr-4" 
                    style="max-width: 270px;max-height:52px" variant="outlined" color="primary" @keyup.enter="loadData('search')"></v-text-field>
                <v-spacer></v-spacer>
                <v-actions>
                  <v-btn  class="mr-2 text-none" variant="flat" v-if="active_tab === 'Return Types Master'" @click="openDialogPopup" color="primary" size="x-large">Add New</v-btn>
                  <v-btn  class="mr-2 text-none" v-if="active_tab !== 'Product Master'" variant="flat" @click="openPopup" color="primary" size="x-large">Download</v-btn>
                  <v-btn  class="mr-2 text-none" v-if="active_tab !== 'Product Master'"  size="x-large" variant="flat" color="primary" @click="navigateToFileUpload">Upload</v-btn>
                  <v-btn  class="mr-2 text-none" v-if="active_tab === 'Product Master'" :disabled="selected.length !== 1" size="x-large" variant="flat" color="primary" @click="deleteProduct">Delete</v-btn>
                  <v-btn  class="mr-2 text-none" v-if="active_tab === 'Product Master'"  size="x-large" variant="flat" color="primary" @click="openDialogPopup">Add</v-btn>
                </v-actions>
                <v-expansion-panels class="custom-control_outlined m-0" ref="filterPopupRef" readonly style="max-width: 300px; margin-bottom: 28px; height: 56px;" v-if="active_tab === 'Entity-Variable Masters' || active_tab === 'Front End Title Master'">
                    <v-expansion-panel variant="outlined" @click="filterListOfButtons">
                        <v-expansion-panel-title>Filter
                        </v-expansion-panel-title>
                    </v-expansion-panel>
                </v-expansion-panels> 
            </v-row>
        </v-card-title>
        <!-- Filter -->
        
        <v-layout column>
        <v-data-table 
            hover
            density="compact"
            :search="search"
            v-model="selected"
            show-select
            disable-pagination
            :hide-default-footer="true"
            :headers="headers"
            :items="table_data"
            :loading="loading"
            :items-per-page="pageSize"
            fixed-header
            height="100%"
            loading-text="Loading Data... Please wait" 
            class="elevation-1"
            return-object
            >
            <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
                <span v-if="header.key === 'action' && (active_tab === 'Return Types Master' || active_tab === 'Product Master')">
                    <v-icon size="large" color="primary" @click="openDialogPopup(item)">mdi-pencil</v-icon>
                </span>
                <span v-else-if="['ria_applicable','rims_applicable','asa_applicable'].includes(header.key)">
                    <v-icon v-if="item[header.key] === true" color="success" size="18">mdi-check</v-icon>
                    <v-icon v-else-if="item[header.key] === false" color="error" size="18">mdi-close-circle-outline</v-icon>
                    <span v-else>-</span>
                </span>
                <span v-else-if="header.key !== 'imags' && item[header.key]">
                    <span v-tooltip="item[header.key]">
                    {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                    </span>
                </span>
                <span v-else>-</span>
                </template>
                <template
                    v-for="key in Object.keys(table_data[0]?.approval_details || {})"
                    v-slot:[`item.approval_details.${key}`]="{ item }" :key="key">
                    {{ item.approval_details?.[key] || '-' }}
                </template>
            <template #bottom></template>
        </v-data-table>
    </v-layout>
    <!-- pagination display -->
     <PaginationComponent
             :pageSize="pageSize"
             :pageSizes="pageSizes"
             :totalCount="totalCount"
             :selected="selected"
             :page="page"
             :totalPages="totalPages"
             @update:pageSize="handlePageSizeChange"
             @update:page="handlePageChange"
             class="mt-2 mb-2"
          />
      </div>
      <div v-else>
      <v-card class="v-card v-sheet theme--light mt-0 overflow-auto v-card-100 dynamic-height-dis-card">
        <v-card-text class="mt-2 pa-0">
          <v-row class="ma-0">
            <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
              <span class="text-align">Organisation Details *</span>
              <div style="line-height: 0.85;">
                <span class="desrciption-text"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever. </span>
              </div>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
              <v-text-field hide-details="auto" v-model="organisation_name" label="Organisation Name" variant="outlined" type="text"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
              <v-text-field hide-details="auto" v-model="address_1" label="Address Line 1" variant="outlined" type="text"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
              <v-text-field hide-details="auto" v-model="address_2" label="Address Line 2" variant="outlined" type="text"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
              <v-row>
                <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
                  <v-text-field hide-details="auto" v-model="country" label="Country" variant="outlined" type="text"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
                  <v-text-field hide-details="auto" v-model="state" label="State" variant="outlined" type="text"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
                  <v-text-field hide-details="auto" v-model="city" label="City" variant="outlined" type="text"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
                  <v-text-field hide-details="auto" v-model="pincode" label="Pincode" variant="outlined" type="text"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
              <span class="text-align">Contact Details *</span>
              <div style="line-height: 0.85;">
                <span class="desrciption-text"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. </span>
              </div>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
            <v-text-field hide-details="auto" v-model="name" label="name" variant="outlined" type="text"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
            <v-text-field hide-details="auto" v-model="email" label="Email" variant="outlined" type="text" :rules="emailRules"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
            <v-text-field hide-details="auto" v-model="mobile_number" label="Mobile Number" variant="outlined" type="text" :rules="phoneRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
              <span class="text-align">Product Selection (RIA/RIMS/ASA) *</span>
              <div style="line-height: 0.85;">
                <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever. </span>
              </div>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
                <v-row>
                    <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                    <v-autocomplete v-model="product_selection" :items="product_selection_items" item-title="name" item-value="name" label="Select Product Selection" variant="outlined" multiple closable-chips chips></v-autocomplete>
                    </v-col>
                </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
              <span class="text-align">Optional Modules Selection *</span>
              <div style="line-height: 0.85;">
                <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.</span>
              </div>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
                <v-row>
                    <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                     <v-autocomplete v-model="module_selection" :items="module_selection_items" item-title="name" item-value="code" label="Select Optional Modules Selection" variant="outlined" multiple closable-chips chips></v-autocomplete>
                    </v-col>
                </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
         <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="flat" class="mt-2 text-none" :disabled="!isFormValid" @click="CreateGeneralSettings"> Save & Proceed</v-btn>
        </v-card-actions>
      </div>
    </v-card>
</template>
<script setup>
import { ref,reactive, onMounted, getCurrentInstance, computed } from 'vue'
import HeaderComponent from "@/components/commoncomponents/HeaderComponent.vue";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
import CommonDialog from '@/components/commoncomponents/CommonDialog.vue';
import data from '@/components/api/v2/ClientConfigurationMasters/clientData.json';
import { useStore } from "vuex";
import { useRouter, useRoute } from 'vue-router'
    const store = useStore();
    const router = useRouter();
    const route = useRoute();   
    const { proxy } = getCurrentInstance(); 
    const headerText = ref('System Masters');
    const loading = ref(false);
    const snackbar = reactive({
        visible: false,
        text: '',
        color: '',
        icon: '',
        timeout: 2000,
        position: 'top',
        mode: 'multi-line'
    });
    const search_tag = ref('');
    const tabs = ref(['Return Types Master',
                      'Entity-Variable Masters',
                      'Notification Types',
                      'Approval Type',
                      'Rule Type',
                      'Grading Type',
                      'Front End Title Master',
                      'Notification Template',
                      'Product Master',
                      'General Setting'
                      ]);
    const tab_index = ref(0);
    const active_tab = ref('Return Types Master');
    const selected = ref([]);
    const table_data = ref([]);
    const headers = ref([{title: "Category", key: "category", minWidth: "200px"},
                        {title: "Issue Code", key: "issue_code", minWidth: "200px"},
                        {title: "Issue Description", key: "issue_description", minWidth: "200px"},
                        {title: "", key: "action", minWidth: "200px"}]);
    const page = ref(1);
    const pageSize = ref(defaultPageSize);
    const pageSizes = ref(defaultPageSizes);
    const totalCount = ref(0);
    const totalPages = ref(1);
    const openDialog = ref(false);
    const return_type = ref('');
    const description = ref('');
    const filterPopupRef = ref(null);
    const filteWithSubPopup = ref(false);
    const data_entry = ref(null);
    const data_entry_items = ref([
        "Return Types Master",
        "Entity-Variable Masters",
        "Notification Types",
        "Approval Type",
        "Rule Type",
        "Grading Type",
        "Front End Title Master",
        "Notification Template",
        "Product Master"]);
    const product = ref('');
    const description_product = ref('');
    const titleText = ref('Add New');
    const uptate_id = ref('');
    const downloadDialog = ref(false);
    const email_id = ref('');
    const email_format_rule = ref((/^[\w,.]+([\.-]?[\w,.]+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email_id.value)) || "Please enter valid Email");
    const isEmailValid = ref(true);
    const emailError = ref('');

    const organisation_name = ref('')
    const address_1 = ref('')
    const address_2 = ref('')
    const country = ref('')
    const state = ref('')
    const city = ref('')
    const pincode = ref('')
    const name = ref('')
    const email = ref('')
    const mobile_number = ref('')
    const product_selection = ref(null)
    const product_selection_items = ref([])
    const module_selection = ref(null)
    const module_selection_items = ref([])
    const emailRules = [
      v => !!v || "Email is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ];
    const phoneRules = [
      v => !!v || "Mobile number is required",
      v => /^[6-9]\d{9}$/.test(v) || "Enter valid 10-digit mobile number",
    ];

   onMounted(() => {
       if(tabs.value.includes(store.state.set_tab)){
        tab_index.value = store.state.set_index;
         loadData(store.state.set_tab,"initiate");
       }else{
         loadData("Return Types Master","initiate");}
   })
  
  const checkFormData = computed(() => {
      if(active_tab.value === "Return Types Master"){
        return (return_type.value !== '' && description.value !== '');
      }else if(active_tab.value === "Product Master"){
        return (product.value !== '' && description_product.value !== '');
      }
  });
  const isFormValid = computed(() => {
      return (
        organisation_name.value.trim() !== '' &&
        address_1.value.trim() !== '' &&
        address_2.value.trim() !== '' &&
        country.value.trim() !== '' &&
        state.value.trim() !== '' &&
        city.value.trim() !== '' &&
        pincode.value.trim() !== '' &&
        name.value.trim() !== '' &&
        email.value.trim() !== '' &&
        mobile_number.value.trim() !== '' &&
        product_selection.value !== null &&
        module_selection.value !== null
      );
    });
   const loadData = (tab, tab_action) => {        
         store.commit("updateTitle", {
            set_tab: tab,
            set_index: tab_index.value,
          })
        if(tab_action){
            search_tag.value = '';
        }  
        loading.value = true;
        selected.value = [];
        table_data.value = [];
        active_tab.value = tab;
        totalPages.value = 1;
        if(tab === 'General Setting'){
          organisation_name.value = '';
          address_1.value = '';
          address_2.value = '';
          country.value = '';
          state.value = '';
          city.value = '';
          pincode.value = '';
          name.value = '';
          email.value = '';
          mobile_number.value = '';
          product_selection.value = null;
          module_selection.value = null;
          getDropdownData();
          return;
        }
        const params = {
            page: page.value,
            per_page: pageSize.value,
        }
        if(search_tag.value != '') {
            params.search = search_tag.value
        }
        if(tab_action === "filter"){
            search_tag.value = '';
          if(active_tab.value === "Front End Title Master")
            params.screen_name = data_entry.value
          else
            params.data_entity = data_entry.value
        }
        let endpoint = '';
        if(active_tab.value === "Return Types Master"){
            endpoint = '/api/v2/return_type_masters';
        }else if(active_tab.value === "Entity-Variable Masters"){
            endpoint = '/api/v2/entity_variable_masters';
        }else if(active_tab.value === "Product Master"){
            endpoint = '/api/v2/org_product_masters';
        }else if(active_tab.value === "Notification Types"){
          endpoint = '/api/v2/system_master_types';
          params.type_category = "notification"
        }else if(active_tab.value === "Approval Type"){
          endpoint = '/api/v2/system_master_types';
          params.type_category = "approval"
        }else if(active_tab.value === "Rule Type"){
          endpoint = '/api/v2/system_master_types';
          params.type_category = "rule"
        }else if(active_tab.value === "Grading Type"){
          endpoint = '/api/v2/system_master_types';
          params.type_category = "grading"
        }else if(active_tab.value === "Notification Template"){
          endpoint = '/api/v2/notification_templates';
        }else if(active_tab.value === "Front End Title Master"){
          endpoint = '/api/v2/front_end_title_masters';
          params.type_category = "title"
        }
        proxy.$httpSecured
        .get(endpoint, { params })
        .then(response => {
          if(response.data) {
            let rows = [];
            if(active_tab.value === "Return Types Master"){
                rows = response.data.return_type_masters;
            }else if(active_tab.value === "Entity-Variable Masters"){
                rows = response.data.entity_variable_masters;
            }else if(active_tab.value === "Product Master"){
                rows = response.data.org_product_masters
            }else if(active_tab.value === "Notification Types" || active_tab.value === "Approval Type" || active_tab.value === "Rule Type" || active_tab.value === "Grading Type"){
                 rows = response.data.types;
                const applicableModules = response.data.applicable_modules || [];
                 rows = rows.map(type => {
                  const newType = { ...type };
                  if ("rim_applicable" in newType) {
                    newType.rims_applicable = newType.rim_applicable;
                    delete newType.rim_applicable;
                  }
                  if(!applicableModules.includes("RIA")) delete newType.ria_applicable;
                  if(!applicableModules.includes("RIMS")) delete newType.rims_applicable;
                  if(!applicableModules.includes("ASA")) delete newType.asa_applicable;
                  return newType;
              });
            }else if(active_tab.value === "Notification Template"){
                rows = response.data.templates
            }else if(active_tab.value === "Front End Title Master"){
              console.log(response.data);
                rows = response.data.titles
            }   
            table_data.value = rows;
            headers.value = [];
            const unique_keys = new Set();
            rows.forEach((row) => {
               Object.keys(row).forEach((key) => {
                   if(key !== "id" && key !== "created_at" && key !== "updated_at" && key !== "is_active" && key !== "deleted_at" && key !== "display_order" && key !== "db_field_name" && key !== "client_defined_title") {
                       unique_keys.add(key);
                   }
               })
            })
            unique_keys.forEach((key) => {
                headers.value.push({
                    title: key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
                    align: 'start',
                    sortable: false,
                    key: key,
                })
            })
            if(active_tab.value === "Return Types Master"){
                 headers.value.push({
                title: "",
                key: "action",
                minWidth: "100px",
                sortable: false
            })
            }
           filteWithSubPopup.value = false;
            data_entry.value = null;
            totalPages.value = response.data.meta.total_pages;
            totalCount.value = response.data.meta.total_count;
            loading.value = false;
          }else{
            loading.value = false;
            proxy.$toast.error("No Data Found");
          }
        })
        .catch(error => {
            loading.value = false;
            proxy.$toast.error(error.response.data.message);
        })
    }
    const openDialogPopup = (item) =>{
        openDialog.value = true;
        if(item.return_type){
            uptate_id.value = item.id;
            titleText.value = "Update";
            return_type.value = item.return_type;
            description.value = item.description;
        }else{  
          titleText.value = "Add New";        
          return_type.value = '';
          description.value = '';
          product.value = '';
          description_product.value = '';
        }
        
    }
    const validateEmail = () => {
        const emails = email_id.value.split(',').map(email => email.trim());
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(emails.length === 1 && !emailPattern.test(emails[0])) {
          emailError.value = 'Please enter a valid email';
          isEmailValid.value = false
          return;
        }else{
          isEmailValid.value = true
        }
        for (const email of emails) {
          if (!emailPattern.test(email)) {
            emailError.value = 'Please enter valid email ids separated by commas';
            isEmailValid.value = false
            return;
          }else{
            isEmailValid.value = true
          }
        }     
        emailError.value = null;
    }
    const openPopup = () => {
      if(selected.value.length > 0){
        downloadFile('selected')
      }else{
        downloadDialog.value = true;
        email_id.value = store.state.currentUser.email;
        validateEmail(email_id.value)
      }        
    }
    const downloadFile = (value) => {
       const formData = new FormData();
       let file_type = '';
       if(active_tab.value === "Return Types Master"){
         file_type = "ReturnTypeUpload";
       }else if(active_tab.value === "Entity-Variable Masters"){
         file_type = "EntityVariableUpload";
       }else if(active_tab.value === "Notification Types"){
         file_type = "SystemMasterTypeDownload";
         formData.append('type_category', "notification");
       }else if(active_tab.value === "Approval Type"){
         file_type = "SystemMasterTypeDownload";
         formData.append('type_category', "approval");
       }else if(active_tab.value === "Rule Type"){
         file_type = "SystemMasterTypeDownload";
         formData.append('type_category', "rule");
       }else if(active_tab.value === "Grading Type"){
         file_type = "SystemMasterTypeDownload";
         formData.append('type_category', "grading");
       }else if(active_tab.value === "Notification Template"){
         file_type = "NotificationTemplateUpload";
       }else if(active_tab.value === "Front End Title Master"){
         file_type = "FrontEndTitleMasterUpload";
       }

       if(value === 'submit'){
         formData.append('email_ids', email_id.value);
         formData.append('file_type', file_type);
       }else{
         const ids = selected.value.map(item => item.id);
         ids.forEach(id => formData.append('ids[]', id));
         formData.append('file_type', file_type);
       }

       let url;
       url = "api/v2/bulk_upload/download_info";
       proxy.$httpSecured
       .post(url, formData)
       .then(response => {
         if (response.data) {
           if(value === 'submit'){
             snackbar.visible = true;
            snackbar.color = "success";
            snackbar.icon = "mdi-check-circle";
            snackbar.mode = "multi-line";
            snackbar.position = "bottom";
            snackbar.timeout = 3000;
            snackbar.title = "Success";
            snackbar.text = response.data.message;
             downloadDialog.value = false;
             email_id.value = '';
           }else{
             const url = response.data.url;
             const link = document.createElement("a");
             link.href = url;
             link.download = "";
             document.body.appendChild(link);
             link.click();
             snackbar.visible = true;
            snackbar.color = "success";
            snackbar.icon = "mdi-check-circle";
            snackbar.mode = "multi-line";
            snackbar.position = "bottom";
            snackbar.timeout = 3000;
            snackbar.title = "Success";
            snackbar.text = "(CSV File) Downloaded Successfully";
           }
         }
       })
       .catch(error => {
        snackbar.visible = true;
        snackbar.color = "success";
        snackbar.icon = "mdi-check-circle";
        snackbar.mode = "multi-line";
        snackbar.position = "bottom";
        snackbar.timeout = 3000;
        snackbar.title = "Success";
        snackbar.text = error.response.data.message;
       })
    }
    const navigateToFileUpload = () => {
         store.commit("setLotIds", {
          lotIds:active_tab.value,
          inventoryId: headerText.value,
          action:'first_tab'
        });
        store.commit("config/ADD_HEADER", headerText.value);
        router.push({ name: "LotFileuploadComm" });
    }
    const filterListOfButtons = () => {
        filteWithSubPopup.value = true;
        fetchFilterData();
        document.documentElement.style.setProperty('--dialog-ypos', (filterPopupRef.value.$el.getBoundingClientRect().top + 40).toString() + 'px');
    }
    const handlePageSizeChange = (size) => {
        pageSize.value = size;
        page.value = 1;
        loadData(active_tab.value);
    }
    const handlePageChange = (newPage) => {
        page.value = newPage;
        loadData(active_tab.value);
    }
    const submitForm = () => {
        if(titleText.value === "Update"){
            proxy.$httpSecured
            .put(`/api/v2/return_type_masters/${uptate_id.value}`, {
              "return_type_master": {  
                description: description.value,
                is_active: true
              }
            })
            .then(response => {
              if (response.data) {
                openDialog.value = false;
                snackbar.visible = true;
                snackbar.color = "success";
                snackbar.icon = "mdi-check-circle";
                snackbar.mode = "multi-line";
                snackbar.position = "bottom";
                snackbar.timeout = 3000;
                snackbar.title = "Success";
                snackbar.text = "Data Updated Successfully";
                loadData(active_tab.value);
              } 
            })
            .catch(error => {
                proxy.$toast.error(error.response.data.message);
            })
        }else{
            const payload = {};
            let end_point = "";

            if(active_tab.value === "Return Types Master") {
            payload.return_type_master = {
                return_type: return_type.value,
                description: description.value,
                is_active: true,
            };
            end_point = "/api/v2/return_type_master"; 
            }else if(active_tab.value === "Product Master") {
            payload.org_product_master = {
                product_name: product.value,
                description: description_product.value,
                is_active: true,
            };
            end_point = "/api/v2/org_product_masters"; 
            }
            proxy.$httpSecured
            .post(end_point, payload)
            .then(response => {
            if (response.data) {
                openDialog.value = false;
                snackbar.visible = true;
                snackbar.color = "success";
                snackbar.icon = "mdi-check-circle";
                snackbar.mode = "multi-line";
                snackbar.position = "bottom";
                snackbar.timeout = 3000;
                snackbar.title = "Success";
                snackbar.text = "Data Added Successfully";
                loadData(active_tab.value);
            } 
            })
            .catch(error => {
                const errors = error.response?.data?.errors;
                if (errors) {
                    const firstKey = Object.keys(errors)[0];
                    const message = errors[firstKey][0];
                    proxy.$toast.error(message);
                }
            });
        }        
    }
    const fetchFilterData = () => {
      let end_point = "";
      if(active_tab.value === "Front End Title Master") {
        end_point = "/api/v2/front_end_title_masters/available_screens";
      }else{
        end_point = "/api/v2/entity_variable_masters/entities";
      }
        proxy.$httpSecured
        .get(end_point)
        .then(response => {
            if(response.data) {
                data_entry_items.value = active_tab.value === "Front End Title Master" ? response.data.screens : response.data.entities;
            }else{
                proxy.$toast.error("No Data Found");
            }
        })
        .catch(error => {
            proxy.$toast.error(error.response.data.message);
        })
    }

    const deleteProduct = () => {
        const id = selected.value.map(x => x.id);
        proxy.$httpSecured
        .delete(`/api/v2/org_product_masters/${id}`)
        .then(response => {
            if (response.data) {
                snackbar.visible = true;
                snackbar.color = "success";
                snackbar.icon = "mdi-check-circle";
                snackbar.mode = "multi-line";
                snackbar.position = "bottom";
                snackbar.timeout = 3000;
                snackbar.title = "Success";
                snackbar.text = "Data Deleted Successfully";
                loadData(active_tab.value);
            } 
        })
        .catch(error => {
            proxy.$toast.error(error.response.data.message);
        })
    }
    const getDropdownData = () => {
        proxy.$httpSecured
        .get(`/api/v2/account_configurations/available_modules`)
        .then(response => {
            if(response.data) {
               module_selection_items.value = response.data.modules;
               getProductList();
            }else{
                proxy.$toast.error("No Data Found");
            }
        })
        .catch(error => {
            proxy.$toast.error("Something went wrong from Network" + error);
        })
    }
    const getProductList = () => {
        proxy.$httpSecured
        .get(`/api/v2/account_configurations/product_options`)
        .then(response => {
            if(response.data) {
                product_selection_items.value = response.data.products;
            }else{
                proxy.$toast.error("No Data Found");
            }
        })
        .catch(error => {
            proxy.$toast.error(error.response.data.message);
        })
    }
   const CreateGeneralSettings = () => {
     const payload = {
      account_configuration: {
        address_line_1: address_1.value,
        address_line_2: address_2.value,
        country: country.value,
        state: state.value,
        city: city.value,
        pincode: pincode.value,
        contact_name: name.value,
        contact_email: email.value,
        contact_mobile: mobile_number.value,
        selected_products: product_selection.value ? product_selection.value : [],
        licensed_modules: module_selection.value ? module_selection.value : []
      }
    };
     proxy.$httpSecured
     .post(`/api/v2/account_configurations`, payload)
     .then(response => {
         if(response.data) {
             snackbar.visible = true;
             snackbar.color = "success";
             snackbar.icon = "mdi-check-circle";
             snackbar.mode = "multi-line";
             snackbar.position = "bottom";
             snackbar.timeout = 3000;
             snackbar.title = "Success";
             snackbar.text = "Data Added Successfully";
             loadData(active_tab.value);
         }else{
             proxy.$toast.error("No Data Found");
         }
     })
     .catch(error => {
         proxy.$toast.error(error.response.data.message);
     })
        
   }
</script>
<style scoped>
 :deep(.custom-tabs .v-tab--selected) {
      text-transform: none;
      color: #002F9E;
      height: 36px !important;
      background-color:#e0e6f559 !important;
      font-size: 12px;
      font-weight: 500 !important;
      line-height: 16.8px !important;
  }
  .v-dialog:has(.filter-dispatch) {
    justify-content: right;
    align-items: baseline;
    top: var(--dialog-ypos);
  }

  .v-dialog>.v-card>:has(.v-card__title) {
    overflow-wrap: break-word !important;
  }

  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }

  .custom-control_outlined button {
    min-height: 56px;
    border-width: 1px;
    border-color: rgba(0, 0, 0, .42);
    border-style: solid;
  }

  .custom-control_outlined button:focus {
    outline: none;
  }
  .dynamic-height-dis-card {
    height: calc(var(--vh, 1vh) * 100 - 200px) !important;
  }
  .desrciption-text{
    font-size: 10px;
    color: #888888;
  }
</style>
